import NextImage from 'next/legacy/image'
import React from 'react'
import style from './ItemAttribute.module.sass'

type ItemAttributeProps = {
	iconUrl: string | undefined
	title: string
}

export const ItemAttribute = React.memo(function ItemAttribute(props: ItemAttributeProps) {
	return (
		<div className={style.iconWrapper}>
			{props.iconUrl && (
				<NextImage src={props.iconUrl} alt={props.title} title={props.title} layout="fill" objectFit="contain" />
			)}
			<p className={style.title}>{props.title}</p>
		</div>
	)
})
